import { FormTextComponent } from 'src/features/generalForms/builder/types/Text';
import { isNullOrEmpty } from 'src/helpers/string-helper';
import { RPDF } from 'src/features/report/react-pdf';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';

export const TextBlock: FormTextComponent = ({ text, isHiddenOnOverview }) => {
  const { visible } = useAnswerRowConditional();
  if (isHiddenOnOverview || !visible || isNullOrEmpty(text)) {
    return <RPDF.View />;
  }

  return (
    <RPDF.Text style={[RPDF.typography.text8, RPDF.tableStyles.divider, { paddingVertical: 8 }]}>{text}</RPDF.Text>
  );
};
